// @ts-nocheck
import type { Question } from '../types';

export const fatigueRestQuestions: Question[] = [
  {
    id: 'q-fr-1',
    topic: 'General',
    question: 'What are the signs of driver fatigue?',
    options: [
      { id: 'q-fr-1o1', text: 'Only yawning' },
      { id: 'q-fr-1o2', text: 'Only heavy eyelids' },
      { id: 'q-fr-1o3', text: 'Yawning, heavy eyelids, difficulty concentrating, and drifting in lane' }
    ],
    answerId: 'q-fr-1o3',
    explanation: 'Signs of driver fatigue include yawning, heavy eyelids, difficulty concentrating, drifting in lane, missing exits, and feeling restless or irritable.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-2',
    topic: 'General',
    question: 'How often should you take breaks on long journeys?',
    options: [
      { id: 'q-fr-2o1', text: 'Every 2 hours' },
      { id: 'q-fr-2o2', text: 'Every 4 hours' },
      { id: 'q-fr-2o3', text: 'Every 6 hours' }
    ],
    answerId: 'q-fr-2o1',
    explanation: 'You should take a break every 2 hours on long journeys, even if you don\'t feel tired. This helps prevent fatigue and maintains alertness.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-3',
    topic: 'General',
    question: 'How long should each break be on a long journey?',
    options: [
      { id: 'q-fr-3o1', text: '5 minutes' },
      { id: 'q-fr-3o2', text: '10 minutes' },
      { id: 'q-fr-3o3', text: '15-20 minutes' }
    ],
    answerId: 'q-fr-3o3',
    explanation: 'Each break should be 15-20 minutes long. This gives you enough time to rest, stretch, and refresh yourself before continuing your journey.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-4',
    topic: 'General',
    question: 'What should you do if you feel tired while driving?',
    options: [
      { id: 'q-fr-4o1', text: 'Continue driving and try to stay awake' },
      { id: 'q-fr-4o2', text: 'Open the window and turn up the radio' },
      { id: 'q-fr-4o3', text: 'Pull over in a safe place and rest' }
    ],
    answerId: 'q-fr-4o3',
    explanation: 'If you feel tired while driving, you should pull over in a safe place and rest. Never try to continue driving when fatigued.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-5',
    topic: 'General',
    question: 'How much sleep should you get before a long journey?',
    options: [
      { id: 'q-fr-5o1', text: '4-5 hours' },
      { id: 'q-fr-5o2', text: '6-7 hours' },
      { id: 'q-fr-5o3', text: '7-8 hours' }
    ],
    answerId: 'q-fr-5o3',
    explanation: 'You should get 7-8 hours of sleep before a long journey to ensure you are well-rested and alert while driving.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-6',
    topic: 'General',
    question: 'What is microsleep?',
    options: [
      { id: 'q-fr-6o1', text: 'A very short nap' },
      { id: 'q-fr-6o2', text: 'A brief period of unconsciousness lasting 1-30 seconds' },
      { id: 'q-fr-6o3', text: 'A deep sleep' }
    ],
    answerId: 'q-fr-6o2',
    explanation: 'Microsleep is a brief period of unconsciousness lasting 1-30 seconds. It can occur without warning and is extremely dangerous while driving.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-7',
    topic: 'General',
    question: 'What should you do if you experience microsleep while driving?',
    options: [
      { id: 'q-fr-7o1', text: 'Continue driving carefully' },
      { id: 'q-fr-7o2', text: 'Pull over immediately and rest' },
      { id: 'q-fr-7o3', text: 'Take a short nap in the car' }
    ],
    answerId: 'q-fr-7o2',
    explanation: 'If you experience microsleep while driving, you should pull over immediately in a safe place and rest. This is a serious warning sign of fatigue.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-8',
    topic: 'General',
    question: 'What is the best time to plan long journeys?',
    options: [
      { id: 'q-fr-8o1', text: 'Early morning when you are fresh' },
      { id: 'q-fr-8o2', text: 'Late afternoon' },
      { id: 'q-fr-8o3', text: 'Late evening' }
    ],
    answerId: 'q-fr-8o1',
    explanation: 'The best time to plan long journeys is early morning when you are fresh and alert. Avoid driving during your normal sleep hours.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-9',
    topic: 'General',
    question: 'What should you avoid before a long journey?',
    options: [
      { id: 'q-fr-9o1', text: 'Heavy meals' },
      { id: 'q-fr-9o2', text: 'Alcohol' },
      { id: 'q-fr-9o3', text: 'All of the above' }
    ],
    answerId: 'q-fr-9o3',
    explanation: 'Before a long journey, you should avoid heavy meals, alcohol, and medications that cause drowsiness, as they can all contribute to fatigue.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-10',
    topic: 'General',
    question: 'What should you do during breaks on long journeys?',
    options: [
      { id: 'q-fr-10o1', text: 'Stay in the car and rest' },
      { id: 'q-fr-10o2', text: 'Get out, stretch, and walk around' },
      { id: 'q-fr-10o3', text: 'Take a long nap' }
    ],
    answerId: 'q-fr-10o2',
    explanation: 'During breaks on long journeys, you should get out of the car, stretch, walk around, and get some fresh air to help stay alert.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-11',
    topic: 'General',
    question: 'What is the recommended maximum driving time per day?',
    options: [
      { id: 'q-fr-11o1', text: '6 hours' },
      { id: 'q-fr-11o2', text: '8 hours' },
      { id: 'q-fr-11o3', text: '10 hours' }
    ],
    answerId: 'q-fr-11o2',
    explanation: 'The recommended maximum driving time per day is 8 hours, including breaks. This helps prevent fatigue and maintains safety.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-12',
    topic: 'General',
    question: 'What should you do if you are driving and start to feel drowsy?',
    options: [
      { id: 'q-fr-12o1', text: 'Continue driving to your destination' },
      { id: 'q-fr-12o2', text: 'Pull over and take a short nap' },
      { id: 'q-fr-12o3', text: 'Drink coffee and continue' }
    ],
    answerId: 'q-fr-12o2',
    explanation: 'If you start to feel drowsy while driving, you should pull over in a safe place and take a short nap. Coffee and other stimulants are not reliable solutions.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-13',
    topic: 'General',
    question: 'When should you take a break if you feel drowsy during driving?',
    options: [
      { id: 'q-fr-13o1', text: 'Only when you reach your destination' },
      { id: 'q-fr-13o2', text: 'Immediately at the next safe location' },
      { id: 'q-fr-13o3', text: 'After driving another 30 minutes' }
    ],
    answerId: 'q-fr-13o2',
    explanation: 'You should stop immediately at the next safe location when you feel drowsy. Delaying a break increases the risk of accident due to fatigue.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-14',
    topic: 'General',
    question: 'What is the most effective way to rest during a long journey?',
    options: [
      { id: 'q-fr-14o1', text: 'Keep the engine running and rest in the car' },
      { id: 'q-fr-14o2', text: 'Park in a safe place and take a 15-20 minute nap' },
      { id: 'q-fr-14o3', text: 'Continue driving with the windows open' }
    ],
    answerId: 'q-fr-14o2',
    explanation: 'A short 15-20 minute nap in a safely parked vehicle is the most effective way to recover from fatigue. This type of rest significantly improves alertness.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-15',
    topic: 'General',
    question: 'How does caffeine affect your ability to drive safely?',
    options: [
      { id: 'q-fr-15o1', text: 'It completely eliminates fatigue' },
      { id: 'q-fr-15o2', text: 'It provides temporary alertness but is not a substitute for proper rest' },
      { id: 'q-fr-15o3', text: 'It has no effect on alertness' }
    ],
    answerId: 'q-fr-15o2',
    explanation: 'Caffeine can provide temporary alertness, but it is not a reliable or safe substitute for proper rest. You should never rely solely on caffeine to stay awake while driving.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-16',
    topic: 'General',
    question: 'What are the main dangers of driving while fatigued?',
    options: [
      { id: 'q-fr-16o1', text: 'Slower reaction time and reduced concentration' },
      { id: 'q-fr-16o2', text: 'Increased risk of accidents and microsleep episodes' },
      { id: 'q-fr-16o3', text: 'Both reduced reaction time and increased accident risk' }
    ],
    answerId: 'q-fr-16o3',
    explanation: 'Fatigued driving causes slower reaction times, reduced concentration, and significantly increases the risk of accidents. Microsleep episodes are particularly dangerous as they occur without warning.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-17',
    topic: 'General',
    question: 'Is listening to loud music effective in preventing driver fatigue?',
    options: [
      { id: 'q-fr-17o1', text: 'Yes, it completely prevents fatigue' },
      { id: 'q-fr-17o2', text: 'No, it is not an effective solution and is dangerous' },
      { id: 'q-fr-17o3', text: 'Yes, but only for short distances' }
    ],
    answerId: 'q-fr-17o2',
    explanation: 'Loud music is not an effective way to prevent fatigue and can actually be dangerous as it distracts from driving. Proper rest is the only reliable solution.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-18',
    topic: 'General',
    question: 'What is the ideal time to plan a break during a long journey?',
    options: [
      { id: 'q-fr-18o1', text: 'After driving 3-4 hours continuously' },
      { id: 'q-fr-18o2', text: 'Only when you feel tired' },
      { id: 'q-fr-18o3', text: 'Every 2 hours, before fatigue sets in' }
    ],
    answerId: 'q-fr-18o3',
    explanation: 'It is best to take breaks every 2 hours before fatigue becomes apparent. Preventive breaks maintain alertness better than waiting until you feel tired.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-19',
    topic: 'General',
    question: 'How does lack of sleep the night before affect your driving ability?',
    options: [
      { id: 'q-fr-19o1', text: 'It has minimal effect on driving' },
      { id: 'q-fr-19o2', text: 'It significantly impairs reaction time, judgment, and alertness' },
      { id: 'q-fr-19o3', text: 'It only affects very long journeys' }
    ],
    answerId: 'q-fr-19o2',
    explanation: 'Lack of sleep significantly impairs your ability to drive safely by reducing reaction time, judgment, and concentration. You should never drive after insufficient sleep.',
    subject: 'Fatigue & Rest'
  },
  {
    id: 'q-fr-20',
    topic: 'General',
    question: 'What should you do if you experience a sudden drowsy spell while driving?',
    options: [
      { id: 'q-fr-20o1', text: 'Increase your speed to stay alert' },
      { id: 'q-fr-20o2', text: 'Pull over immediately in a safe location and rest' },
      { id: 'q-fr-20o3', text: 'Continue driving and splash water on your face' }
    ],
    answerId: 'q-fr-20o2',
    explanation: 'If you experience a sudden drowsy spell, you must pull over immediately in a safe location. This is a critical warning sign and should never be ignored.',
    subject: 'Fatigue & Rest'
  }
];
